import Vue from 'vue';
export default Vue.extend({
    data() {
        return {
            reviews: [],
        };
    },
    created() {
        // this.reviews = getMockReviews();
    },
    methods: {},
});
